import type { FC, ReactNode } from 'react';
import { useCallback, useMemo } from 'react';
import { LazyLoadImage } from '@components/reactLazyLoadImageComponent';
import UIicons from '@ui-kit';
import { createImageErrorHandler } from '@utils/onImageError';
import { observer } from 'mobx-react';
import './index.scss';

const { productCardErrorImg } = UIicons;

const onImgError = createImageErrorHandler(productCardErrorImg.x3);

interface DesktopProductImgWrapperProps {
  isBarMenuCurrentPath?: boolean;
  imgsArr: string[];
  title: string;
  InStoreBlockComp: ReactNode;
  currentSlide: number;
  productNotInCart: boolean;
  omImgHoverEnd?: () => void;
  setCurrentSlide: (value: number) => void;
}

const DesktopProductImgWrapper: FC<DesktopProductImgWrapperProps> = observer(
  ({
    imgsArr,
    title,
    InStoreBlockComp,
    currentSlide,
    omImgHoverEnd,
    setCurrentSlide,
    productNotInCart
  }) => {
    const isShowControllers = useMemo(
      () => imgsArr.length > 1,
      [imgsArr.length]
    );

    const handleHoverZone = useCallback(
      (index: number) => {
        if (isShowControllers && productNotInCart) {
          setCurrentSlide(index);
        }
      },
      [isShowControllers, productNotInCart, setCurrentSlide]
    );

    const handleMouseLeave = useCallback(() => {
      if (omImgHoverEnd && isShowControllers && productNotInCart) {
        omImgHoverEnd();
      }
      if (isShowControllers && productNotInCart && currentSlide !== 0) {
        setCurrentSlide(0);
      }
    }, [
      omImgHoverEnd,
      isShowControllers,
      productNotInCart,
      currentSlide,
      setCurrentSlide
    ]);

    return (
      <div className='ProductImgWrapper' onMouseLeave={handleMouseLeave}>
        <div
          className='ProductImgWrapper__track'
          style={{
            transform: `translateX(-${currentSlide * 100}%)`
          }}
        >
          {!!imgsArr?.length &&
            imgsArr.map((item, index) => (
              <div key={item} className='ProductImgWrapper__img-wrapper'>
                {InStoreBlockComp && InStoreBlockComp}
                <LazyLoadImage
                  draggable={false}
                  onError={onImgError}
                  visibleByDefault={index === 0}
                  className='ProductImgWrapper__img'
                  src={item || productCardErrorImg.x3}
                  alt={title}
                />
              </div>
            ))}
        </div>

        {isShowControllers && productNotInCart && (
          <div className='ProductImgWrapper__hover-zones'>
            {imgsArr.map((_, index) => (
              <div
                key={index}
                className='ProductImgWrapper__hover-zone'
                onMouseEnter={() => {
                  handleHoverZone(index);
                }}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
);

export default DesktopProductImgWrapper;
